import moment from 'moment';

export const DEFAULT_DATE_PRESET = 'last_7_days';

export const DATE_PRESET_OPTIONS = [
    { id: 'today', label: 'Today' },
    { id: 'last_7_days', label: 'Last 7 days' },
    { id: 'last_month', label: 'Last month' },
    { id: 'last_3_months', label: 'Last 3 months' },
    { id: 'custom', label: 'Custom range' },
];

export const getPresetDateRange = (presetId) => {
    const today = moment();
    switch (presetId) {
        case 'today':
            return {
                from: today.clone().startOf('day').format('YYYY-MM-DD'),
                to: today.clone().endOf('day').format('YYYY-MM-DD'),
            };
        case 'last_7_days':
            return {
                from: today.clone().subtract(6, 'days').startOf('day').format('YYYY-MM-DD'),
                to: today.clone().endOf('day').format('YYYY-MM-DD'),
            };
        case 'last_month': {
            const lastMonth = today.clone().subtract(1, 'month');
            return {
                from: lastMonth.startOf('month').format('YYYY-MM-DD'),
                to: lastMonth.endOf('month').format('YYYY-MM-DD'),
            };
        }
        case 'last_3_months':
            return {
                from: today.clone().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'),
                to: today.clone().endOf('day').format('YYYY-MM-DD'),
            };
        default:
            return {
                from: today.clone().subtract(6, 'days').startOf('day').format('YYYY-MM-DD'),
                to: today.clone().endOf('day').format('YYYY-MM-DD'),
            };
    }
};

export const formatDateRangeLabel = (from, to) => {
    if (!from || !to) return '';
    const start = moment(from, 'YYYY-MM-DD');
    const end = moment(to, 'YYYY-MM-DD');
    if (!start.isValid() || !end.isValid()) return '';
    if (start.year() === end.year()) {
        return `${start.format('MMM D')} - ${end.format('MMM D, YYYY')}`;
    }
    return `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`;
};

export const buildDashboardDateParams = ({ preset, from, to }) => ({
    preset: preset === 'custom' ? 'custom' : preset,
    from,
    to,
});

export const getDateRangeKey = (range) => `${range.preset}|${range.from}|${range.to}`;

export const parseDateRangeFromSearchParams = (searchParams) => {
    const preset = searchParams.get('preset');
    const from = searchParams.get('from');
    const to = searchParams.get('to');

    if (preset === 'custom' && from && to) {
        const start = moment(from, 'YYYY-MM-DD', true);
        const end = moment(to, 'YYYY-MM-DD', true);
        if (start.isValid() && end.isValid() && !end.isBefore(start)) {
            return { preset: 'custom', from, to };
        }
    }

    if (preset && preset !== 'custom' && DATE_PRESET_OPTIONS.some((option) => option.id === preset)) {
        return { preset, ...getPresetDateRange(preset) };
    }

    if (from && to) {
        const start = moment(from, 'YYYY-MM-DD', true);
        const end = moment(to, 'YYYY-MM-DD', true);
        if (start.isValid() && end.isValid() && !end.isBefore(start)) {
            return { preset: 'custom', from, to };
        }
    }

    return { preset: DEFAULT_DATE_PRESET, ...getPresetDateRange(DEFAULT_DATE_PRESET) };
};

export const buildDateSearchParams = (dateRange) => {
    const params = new URLSearchParams();
    params.set('preset', dateRange.preset || DEFAULT_DATE_PRESET);
    if (dateRange.from) {
        params.set('from', dateRange.from);
    }
    if (dateRange.to) {
        params.set('to', dateRange.to);
    }
    return params;
};

export const getPresetLabel = (presetId) => (
    DATE_PRESET_OPTIONS.find((option) => option.id === presetId)?.label || 'Last 7 days'
);
